(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("axios"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("vue-ocr", ["axios", "vue"], factory);
	else if(typeof exports === 'object')
		exports["vue-ocr"] = factory(require("axios"), require("vue"));
	else
		root["vue-ocr"] = factory(root["axios"], root["vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_OMN4__, __WEBPACK_EXTERNAL_MODULE_lRwf__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition